/* eslint-disable  no-underscore-dangle */
import tippy from 'tippy.js';
import configs from '@/plugins/configs.js';

const plugin = {
    install(Vue) {
        function createTippy(el, binding) {
            let options = {
                arrow: false,
                offset: [0, 5],
                showOnMobile: false,
                onShow(instance) {
                    return !!instance.props.content;
                },
            };

            if (typeof binding.value === 'object') {
                options = { ...options, ...binding.value };
            } else if (typeof binding.value === 'string') {
                options.content = binding.value;
            }

            if (!options.showOnMobile && configs.isMobile) {
                return;
            }

            delete options.showOnMobile;

            tippy(el, options);

            if (options.showOnLoad) {
                el._tippy.show();
            }
        }

        Vue.directive('tooltip', {
            inserted(el, binding, vnode) {
                Vue.nextTick(() => {
                    createTippy(el, binding, vnode);
                });
            },

            unbind(el) {
                if (!el._tippy) {
                    return;
                }

                el._tippy.destroy();
            },

            componentUpdated(el, binding) {
                if (!el._tippy) {
                    return;
                }

                let options = {};

                if (typeof binding.value === 'object') {
                    options = { ...binding.value };
                } else if (typeof binding.value === 'string') {
                    options.content = binding.value;
                }

                el._tippy.setProps(options);
            },
        });
    },
};

export default plugin;
